export default __webpack_public_path__ + "static/media/linkedin.c79d66e9.svg";